class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    window.addEventListener('hp-cart-sync:cart-updated', () => {
      this.updateCartDrawerContent();
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-link');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  updateCartDrawerContent() {
    fetch(window.hpI18n.url(`/cart?sections=cart-drawer,cart-icon-bubble&timestamp=${Date.now()}`))
      .then(r => r.json())
      .then(sections => {
        const parser = new DOMParser();
        
        // Cart drawer içeriğini güncelle
        const drawerDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        const drawerElement = this.querySelector('#CartDrawer');
        if (drawerElement) {
          drawerElement.innerHTML = drawerDoc.querySelector('#CartDrawer').innerHTML;
        }

        // Cart icon bubble'ı güncelle
        const bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        const bubbleEl = document.getElementById('cart-icon-bubble');
        if (bubbleEl) {
          bubbleEl.innerHTML = bubbleDoc.querySelector('.shopify-section').innerHTML;
        }

        // Quantity button'ları güncelle
        this.querySelectorAll('quantity-input').forEach(el => {
          const line = el.dataset.line;
          this.updateQuantityButtons(line);
        });

        // Event listener'ları yeniden bağla
        this.reattachEventListeners();
      })
      .catch(console.error);
  }

  updateQuantityButtons(line) {
    const wrapper = this.querySelector(`quantity-input[data-line="${line}"]`);
    if (!wrapper) return;
    const input = wrapper.querySelector('.quantity__input');
    const minusBtn = wrapper.querySelector('button[name="minus"]');
    const plusBtn = wrapper.querySelector('button[name="plus"]');
    const qty = parseInt(input.value, 10) || 0;
    const stock = parseInt(wrapper.dataset.stock, 10) || 0;
    const min = parseInt(input.min, 10) || 1;

    minusBtn.disabled = qty <= min;
    plusBtn.disabled = qty >= stock;
  }

  reattachEventListeners() {
    // Overlay click event'ini yeniden bağla
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

(() => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  let isUpdating = false;

  function updateQuantityButtons(line) {
    const wrapper = drawer.querySelector(`quantity-input[data-line="${line}"]`);
    if (!wrapper) return;
    const input    = wrapper.querySelector('.quantity__input');
    const minusBtn = wrapper.querySelector('button[name="minus"]');
    const plusBtn  = wrapper.querySelector('button[name="plus"]');
    const qty      = parseInt(input.value, 10) || 0;
    const stock    = parseInt(wrapper.dataset.stock, 10) || 0;
    const min      = parseInt(input.min, 10) || 1;

    minusBtn.disabled = qty <= min;
    plusBtn.disabled  = qty >= stock;
  }

  drawer.addEventListener('transitionend', () => {
    drawer.querySelectorAll('quantity-input').forEach(el => {
      updateQuantityButtons(el.dataset.line);
    });
  }, { once: true });

  drawer.addEventListener('click', (e) => {
    if (isUpdating) return;
    const btn = e.target.closest('.quantity__button');
    if (!btn) return;

    const wrapper = btn.parentElement;
    const input   = wrapper.querySelector('.quantity__input');
    const line    = Number(input.dataset.index);
    let qty       = parseInt(input.value, 10) || 0;
    const stock   = parseInt(wrapper.dataset.stock, 10) || 0;
    const min     = parseInt(input.min, 10) || 1;

    qty = btn.name === 'minus' ? qty - 1 : qty + 1;
    if (qty < min)   qty = min;
    if (qty > stock) qty = stock;

    input.value = qty;
    updateQuantityButtons(line);
    updateCartLine(line, qty);
  });

  drawer.addEventListener('change', (e) => {
    if (isUpdating) return;
    const input = e.target.closest('.quantity__input');
    if (!input) return;

    const line  = Number(input.dataset.index);
    let qty     = parseInt(input.value, 10) || 0;
    const min   = parseInt(input.min, 10) || 1;
    const stock = parseInt(input.max, 10) || parseInt(input.parentElement.dataset.stock, 10) || 0;

    if (qty < min)   qty = min;
    if (qty > stock) qty = stock;

    input.value = qty;
    updateQuantityButtons(line);
    updateCartLine(line, qty);
  });

  async function updateCartLine(line, quantity) {
    const requestedQty = quantity;
    isUpdating = true;
    drawer.classList.add('changing');

    try {
      await fetch(window.hpI18n.url('/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      
      const r = await fetch(window.hpI18n.url(`/cart?sections=cart-drawer,cart-icon-bubble&timestamp=${Date.now()}`));
      const sections = await r.json();
      
      // Check and update cart discount before UI update
      await checkAndUpdateCartDiscount();
      
      const parser    = new DOMParser();
      const drawerDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      drawer.querySelector('#CartDrawer').innerHTML = drawerDoc.querySelector('#CartDrawer').innerHTML;

      const bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      const bubbleEl  = document.getElementById('cart-icon-bubble');
      if (bubbleEl) bubbleEl.innerHTML = bubbleDoc.querySelector('.shopify-section').innerHTML;

      drawer.querySelectorAll('.cart-item__stock-error').forEach(el => {
        el.textContent = '';
        el.style.display = 'none';
      });
      const inputEl   = drawer.querySelector(`#Quantity-${line}`);
      const actualQty = parseInt(inputEl.value, 10);
      if (actualQty < requestedQty) {
        const errorEl = drawer.querySelector(`#CartDrawer-StockError-${line}`);
        errorEl.textContent = window.hpI18n.t('theme_i18n.cart.stock_insufficient');
        errorEl.style.display = 'block';
      }

      updateQuantityButtons(line);
      drawer.querySelectorAll('quantity-input').forEach(el =>
        updateQuantityButtons(el.dataset.line)
      );

      const overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
    } catch (error) {
      console.error(error);
    } finally {
      drawer.classList.remove('changing');
      isUpdating = false;
    }
  }

})();